'use client';

import { useState } from 'react';
import { Camera } from 'lucide-react';

/**
 * Foto del directorio con fallback robusto. Muchas fotos son links a Google Maps
 * (que expiran) o a webs externas; si la imagen no carga, mostramos un placeholder
 * limpio en vez del icono roto del navegador.
 *
 * Mismo patrón de estado que DirectoryListingCard (useState + onError).
 */
export function DirectoryPhoto({
  url,
  alt,
  className = '',
  imgClassName = '',
}: {
  url: string;
  alt: string;
  className?: string;
  imgClassName?: string;
}) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-gray-50 ${className}`}>
        <Camera className="h-8 w-8 text-gray-300" />
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={imgClassName || className}
    />
  );
}
